export const APP_ROUTES = {
  socials: "/socials",
  explore: "/explore",
  events: "/events",
  admin: "/admin",
};
